import { useState } from 'react'
import { Form } from 'antd'

const useDischargeModals = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [viewDischarge, setViewDischarge] = useState(null)
  const [form] = Form.useForm()

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
  }

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real application, this would add the new discharge instructions to the database
        setIsModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  const handleView = (discharge) => {
    setViewDischarge(discharge)
  }

  const handleCloseView = () => {
    setViewDischarge(null)
  }

  return {
    isModalVisible,
    viewDischarge,
    form,
    showModal,
    handleCancel,
    handleCreate,
    handleView,
    handleCloseView
  }
}

export default useDischargeModals
